import { FC } from 'react';
import { StyledDivider, CardWrapper, CardContent, StyledSkeletonContainer } from './Styled';

type CardProps = {
  testId?: string;
  cardHeader: JSX.Element;
  height: string | number;
  loading: boolean;
};

export const Card: FC<React.PropsWithChildren<CardProps>> = ({
  testId,
  cardHeader,
  height,
  loading,
  children,
}) => {
  return (
    <CardWrapper data-test={testId}>
      {cardHeader}
      <StyledDivider />
      <StyledSkeletonContainer isLoading={loading} height={loading ? height : 'auto'}>
        {!loading && <CardContent>{children}</CardContent>}
      </StyledSkeletonContainer>
    </CardWrapper>
  );
};
